import { connect } from 'react-redux';
import IntercomActivationView from './IntercomActivationView.jsx';
import { activateAccount, updateConfiguration } from 'src/legacy/redux/actions/chatIntegration.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    activating: state.legacyRootReducer.settings.integrations.chat.activation.activating,
    error: state.legacyRootReducer.settings.integrations.chat.activation.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration, integrationType) => {
        return dispatch(activateAccount(configuration, integrationType))
    },
    updateConfiguration : (configuration, integrationType) => {
      return dispatch(updateConfiguration(configuration, integrationType))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const IntercomActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(IntercomActivationView);

export default IntercomActivationPage;
